import { OrganizationGroupDto } from "@dialogics/shared/dto/types"
import { ColumnDef, Row } from "@tanstack/react-table"
import { Link } from "react-router-dom"
import { useModal } from "../../component/modal"
import { ReactTailwindTable, useTable } from "../../component/react-tailwind-table"
import { OrganizationGroupForm } from "./organization-group-form"
import { useGetOrganizationGroupsQuery } from "./organization-group-service"

export const OrganizationGroupListPage = ({ organizationId }: { organizationId: number }) => {
  const { pagination, setPagination } = useTable({
    defaultPageSize: 10,
  })
  const {
    isOpen: isFormOpen,
    openModal: openForm,
    closeModal: closeForm,
    data: organizationGroup,
  } = useModal<OrganizationGroupDto>()

  const columns: ColumnDef<OrganizationGroupDto>[] = [
    {
      accessorKey: "code",
      header: "Код",
    },
    {
      id: "actions",
      cell: ({ row }: { row: Row<OrganizationGroupDto> }) => (
        <div>
          <Link to={`/app/admin/organization-groups/${row.original.id}`} className="btn btn-sm btn-secondary">
            Редактировать
          </Link>
        </div>
      ),
    },
  ]

  return (
    <div className="max-w-7xl mx-auto bg-white dark:bg-base-200 p-6 sm:p-8 rounded-lg shadow-sm">
      <div className="flex justify-between items-center mb-4">
        <h1 className="text-2xl">Конфигурации</h1>
        <button className="btn btn-primary" onClick={() => openForm()}>
          Создать конфигурацию
        </button>
      </div>
      <ReactTailwindTable
        query={useGetOrganizationGroupsQuery}
        queryParams={{ organizationId }}
        columns={columns}
        pagination={pagination}
        setPagination={setPagination}
      />
      <OrganizationGroupForm isOpen={isFormOpen} onClose={closeForm} organizationGroup={organizationGroup} organizationId={organizationId} />
    </div>
  )
}
